import { Amendment } from "../domain/amendment";
import { IAmendmentRepository } from "../ports/outbound/IAmendmentRepository";

export class AmendmentUseCases {
    constructor(
        private readonly amendmentRepository: IAmendmentRepository
    ) {

    }
    fetchAmendmentHistory(i9FormId: string): Promise<Array<Amendment>> {
        return this.amendmentRepository.fetchAmendmentHistory(i9FormId);
    }
}